export default __webpack_public_path__ + "static/media/Vechur01_punnayurkulam_landscape.47dca1a1.webp";